module.exports = __webpack_public_path__ + "img/OhringeMarkeEigenbau.a37ba3fa.jpg";